import http from "../http-common";
/* eslint-disable */
class PaketMembershipUserService {
  paketList(page, itemPerPage, keyword) {
    return http.get(
      "/paket-membership-user/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("user_id", data.user_id);
    bodyFormData.append("tipe_user", data.selectedTipeUser.code);
    bodyFormData.append("paket_membership_id", data.paket_membership_id);
    bodyFormData.append("tanggal", data.tanggal);

    return http.post("/paket-membership-user", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("user_id", data.user_id);
    bodyFormData.append("tipe_user", data.selectedTipeUser.code);
    bodyFormData.append("paket_membership_id", data.paket_membership_id);
    bodyFormData.append("tanggal", data.tanggal);
    bodyFormData.append("status", data.selectedStatusPaket.code);

    return http.put(`/paket-membership-user/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/paket-membership-user/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  konfirmasiPembayaran(id, userId) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("user_id", userId);

    return http.put(`/paket-membership-konfirmasi/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new PaketMembershipUserService();
